import { render, staticRenderFns } from "./OrderCollectionOnDehalf.vue?vue&type=template&id=65d0e9ce&scoped=true"
import script from "./OrderCollectionOnDehalf.vue?vue&type=script&lang=js"
export * from "./OrderCollectionOnDehalf.vue?vue&type=script&lang=js"
import style0 from "./OrderCollectionOnDehalf.vue?vue&type=style&index=0&id=65d0e9ce&prod&lang=scss&scoped=true"
import style1 from "./OrderCollectionOnDehalf.vue?vue&type=style&index=1&id=65d0e9ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d0e9ce",
  null
  
)

export default component.exports